import React from 'react';
import { Defect } from '../services/defectService';

interface StatsBarProps {
  defects: Defect[];
  totalRecords?: number;
  totalValidatedTrue?: number;
  totalValidatedFalse?: number;
  totalsAreApproximate?: boolean;
  hasMoreRecords?: boolean;
}

const StatsBar: React.FC<StatsBarProps> = ({
  defects,
  totalRecords = 0,
  totalValidatedTrue = 0,
  totalValidatedFalse = 0,
  totalsAreApproximate = false,
  hasMoreRecords = false,
}) => {
  const pageStats = {
    total: defects.length,
    open: defects.filter((d) => d.status === 'Open').length,
    closed: defects.filter((d) => d.status === 'Closed').length,
    validated: defects.filter((d) => d.validation === true).length,
    notValidated: defects.filter((d) => d.validation === false || d.validation === undefined).length,
  };

  const totalRecordsLabel = totalsAreApproximate && hasMoreRecords
    ? `${totalRecords.toLocaleString()}+`
    : totalRecords.toLocaleString();

  const validatedLabel = totalsAreApproximate
    ? '...'
    : totalValidatedTrue.toLocaleString();

  const notValidatedLabel = totalsAreApproximate
    ? '...'
    : totalValidatedFalse.toLocaleString();

  return (
    <div className="stats-bar">
      <div className="stat-card stat-card-primary">
        <span className="stat-label">Toplam Hata</span>
        <span className="stat-value">{totalRecordsLabel}</span>
      </div>
      <div className="stat-card stat-card-success">
        <span className="stat-label">✓ Doğrulandı</span>
        <span className="stat-value">
          {validatedLabel}
          <span className="stat-page-count"> ({pageStats.validated})</span>
        </span>
      </div>
      <div className="stat-card stat-card-danger">
        <span className="stat-label">✗ Doğrulanmamış</span>
        <span className="stat-value">
          {notValidatedLabel}
          <span className="stat-page-count"> ({pageStats.notValidated})</span>
        </span>
      </div>
      <div className="stat-card">
        <span className="stat-label">Bu Sayfada</span>
        <span className="stat-value">{pageStats.total}</span>
      </div>
    </div>
  );
};

export default StatsBar;
